
const url = '/order/v1';
export default API => ({
    // 获取分类
    branchGetGoodsCategoryLevelOne() {
        return API({
            url:`${url}/platform/goodsCategory/branchGetGoodsCategoryLevelOne`,
        });
    },
    // 头部课程供销商
    findBranchList() {
        return API({ 
            url: `${url}/channel/distributionGoods/findBranchList`,
            method:'post' 
        });
    },
    //资源商城课程列表
    findDistributionGoods(params,data){
        return API({ 
            url: `${url}/channel/distributionGoods/findDistributionGoods`,
            method:'post',
            params,
            data 
        });
    },
    //分销商品列表(渠道端)
    // findByCondition() {
    //     return API({
    //         url:`${url}/channel/distributionGoods/findByCondition`
    //     });
    // },
})